module.exports = __webpack_public_path__ + "static/media/P1090881a.9b96909e.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/akopan/P1090881a.JPG
// module id = 35
// module chunks = 0